//渐变色
export const myColors = ["#e57373", "#039be5", "#cfeeef"];

